import React from "react";
import { Link } from "react-router-dom";

const Footer = () => (
  <footer className="footer-app">
    <span>
      Todos los derechos reservados
      {' | '}
      <Link to="/terminos">Términos y condiciones</Link>
      {' | '}
      <Link to="/privacidad">Política de privacidad</Link>
    </span>
  </footer>
);

export default Footer;
